import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-847c1454"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bi-tmpl-detail__right__cmpt" }
const _hoisted_2 = { class: "bi-tmpl-detail__right__cmpt__tips" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "bi-tmpl-detail__right__cmpt__tips",
    style: {"margin-top":"0"}
  }, " 请选择表格样式 ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "bi-tmpl-detail__right__cmpt__tips" }, "请选择图表样式")
], -1))
const _hoisted_5 = { style: {"padding":"10px 24px","font-size":"14px","border":"1px solid #dbdbdb","margin-top":"20px","color":"#484848"} }

import { BaseRadio, BaseCard } from 'xrk-components';
import { Carousel } from '@/components/base/carousel';
import PcModulePercent from '../bi-pc-module/pc-module-table/index';
import PcModuleBigTable from '../bi-pc-module/pc-module-complex-table/index';
import { multiSample } from '../../mock/_multi-sample';

import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';


export default /*#__PURE__*/_defineComponent({
  __name: 'bi-tmpl-detail-7',
  setup(__props) {

const TYPE_MAPPING1 = PcModulePercent.reduce((pre, cur, i) => {
  const cName = cur.__name;
  pre[cName] = {
    cmpt: cur,
    value: 'pc-module-table-' + (i + 1),
    moduleType: cName
  };
  return pre;
}, {});

const TYPE_MAPPING2 = PcModuleBigTable.reduce((pre, cur, i) => {
  const cName = cur.__name;
  pre[cName] = {
    cmpt: cur,
    value: 'pc-module-complex-table-' + (i + 1),
    moduleType: cName
  };
  return pre;
}, {});

const cmpName = (name, modules) => {
  return modules.filter(comp => comp.__name === name)[0];
};

const { curItem, onChange } = useDetailCmpt({});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(curItem).tips), 1),
    _hoisted_3,
    _createVNode(_unref(Carousel), {
      ref: "carouselRef",
      itemHeight: 200,
      itemWidth: 420 + 56
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TYPE_MAPPING1), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            style: {"height":"200px","width":"100%"},
            key: index
          }, [
            _createVNode(_unref(BaseCard), { style: {"width":"420px","height":"200px"} }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseRadio), {
                  class: "bi-tmpl-detail__right__cmpt__radio bi-tmpl-detail__right__cmpt__radio--w table",
                  value: item.value,
                  "model-value": _unref(curItem).value,
                  onClick: ($event: any) => (_unref(onChange)(item.value))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(cmpName(item.moduleType, _unref(PcModulePercent))), _mergeProps({
                      style: {"width":"1200px","transform":"scale(0.32)","transform-origin":"center 0","white-space":"wrap"},
                      ref_for: true
                    }, {
                tableHeaderList: _unref(multiSample)[0].table.header,
                tableDataList: _unref(multiSample)[0].table.value
              }), null, 16))
                  ]),
                  _: 2
                }, 1032, ["value", "model-value", "onClick"])
              ]),
              _: 2
            }, 1024)
          ]))
        }), 128))
      ]),
      _: 1
    }, 512),
    _hoisted_4,
    _createVNode(_unref(Carousel), {
      ref: "carouselRef",
      itemHeight: 515,
      itemWidth: 420 + 56
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TYPE_MAPPING2), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            style: {"height":"500px","width":"100%"},
            key: index
          }, [
            _createVNode(_unref(BaseCard), { style: {"width":"420px","height":"500px"} }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseRadio), {
                  class: "bi-tmpl-detail__right__cmpt__radio bi-tmpl-detail__right__cmpt__radio--w table2",
                  value: item.value,
                  "model-value": _unref(curItem).value,
                  onClick: ($event: any) => (_unref(onChange)(item.value))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(cmpName(item.moduleType, _unref(PcModuleBigTable))), _mergeProps({
                      style: {"width":"1200px","transform":"scale(0.32)","transform-origin":"center 0","white-space":"wrap"},
                      ref_for: true
                    }, {
                tableHeaderList: _unref(multiSample)[0].extTable.header,
                tableDataList: _unref(multiSample)[0].extTable.value
              }), null, 16))
                  ]),
                  _: 2
                }, 1032, ["value", "model-value", "onClick"])
              ]),
              _: 2
            }, 1024)
          ]))
        }), 128))
      ]),
      _: 1
    }, 512),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", null, _toDisplayString(_unref(multiSample)[0].extTable.summary), 1)
    ])
  ]))
}
}

})